import React from "react";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
	image: {
		maxWidth: "100%",
		height: "auto",
		borderRadius: theme.shape.borderRadius,
	},
}));
export default function Animation(props) {
	const { src = "", alt = "", defaultText = "Coming Soon" } = props;
	const setDefaultImage = (event) => {
		event.target.src = `https://via.placeholder.com/600x338.gif?text=${defaultText}`;
	};
	return (
		<img
			className="figure-img img-thumbnail img-fluid rounded"
			src={`${process.env.PUBLIC_URL}/${src}`}
			alt={alt}
			onError={setDefaultImage}
		/>
	);
}

export function Image(props) {
	const { src = "", alt = "", defaultText = "Coming Soon", ...other } = props;
	const classes = useStyles();
	const setDefaultImage = (event) => {
		event.target.src = `https://via.placeholder.com/600x338.gif?text=${defaultText}`;
	};
	return (
		<img
			className={classes.image}
			src={`${process.env.PUBLIC_URL}/${src}`}
			alt={alt}
			onError={setDefaultImage}
			onLoad={() => console.log("loaded")}
		/>
	);
}
